export const writeProgress = {
  name: "WriteProgress",
  excerpt: "Tool To Help Writers Track Their Writing",
  image: "writeProgress.jpg",
  localUrl: "writeProgress",
  url: "https://www.writeProgress.com",
  description:
    "WriteProgress is a Sass application that helps writers write more by tracking their writing. It provides tools for tracking writing, along with additional features to help writers improve.",
}
